"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TALLY_SETTING_PROBLEMS = void 0;
/**
 * A Tally setting that stops orders from going in, as the connector found it on the PC:
 * - sales-order-inactive: the Sales Order voucher type is inactive (TallyPrime ships it so);
 * - zero-value-not-allowed: it doesn't allow zero-valued transactions (orders without prices);
 * - sales-ledger-missing: there is no ledger named "Sales" for the order's sales entries.
 */
exports.TALLY_SETTING_PROBLEMS = [
    'sales-order-inactive',
    'zero-value-not-allowed',
    'sales-ledger-missing',
];
//# sourceMappingURL=connector.js.map